import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, useForm} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import MetaInfoForm from "@/Pages/MetaInfo/Assets/MetaInfoForm";

const Create = () => {
  const {data, setData, errors, post, processing} = useForm({
    title: '',
    description: '',
    keywords: '',
    url: '',
    def_image_logo: null,
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('static-page.store').url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('static-page')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Static Pages
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <MetaInfoForm  errors={errors} data={data} setData={setData}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create Banner
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Create.layout = page => <Layout title="Create meta info" children={page}/>;

export default Create;
